export const popper = (
  callback: Function,
  referenceElement: any,
  popperElement: any,
  card: any
): any =>
  callback(referenceElement, popperElement, {
    placement: Boolean(card) ? 'top-end' : 'bottom-end',
    modifiers: [
      {
        name: 'offset',
        enabled: true,
        options: {
          offset: [0, 15],
        },
      },
      {
        name: 'flip',
        enabled: Boolean(card),
        options: {
          boundary: card,
          altBoundary: true,
          allowedAutoPlacements: ['top', 'bottom'],
        },
      },
    ],
  })
